import { AlarmPriorities } from "./AlarmPriorities";
export default AlarmPriorities;
